import { Button, Modal, Select, Form, message } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import IconClose from '@/assets/images/icons/icon-close.react.svg?react';
import { getProductId } from '@/infrastructure/product-info';
import { FILED_OPTIONS } from '@/presentation/pages/diagnose/log/utils';
import { useStores } from '@/presentation/store';
import { productOAServer } from '@/service/productoa';
import styles from './index.module.scss';
// 更新字段名
export const UpdateField = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const { product } = useStores().ProductStore;
  const [form] = Form.useForm();

  const updateClick = () => {
    setVisible(true);
    setModalLoading(true);
    form.setFieldsValue({
      field: product?.diagnoseGuidMappingField,
    });
    setModalLoading(false);
  };
  const onCancel = () => {
    if (submitLoading) {
      return;
    }
    setVisible(false);
    setSubmitLoading(false);
    form.resetFields();
  };

  const onOk = async () => {
    setSubmitLoading(true);
    const fieldsValue = form.getFieldValue('field');
    const productId = getProductId();
    const info = await productOAServer.getProductOaInfo({ appId: productId });
    if (!info?.appId) {
      setSubmitLoading(false);
      return;
    }
    const res = await productOAServer.updateProductOa({
      ...info,
      appId: getProductId(),
      diagnoseGuidMappingField: fieldsValue,
    });
    setSubmitLoading(false);
    if (!res) {
      return;
    }
    message.success(t('更新成功'));
    setVisible(false);
    setSubmitLoading(false);
    location.reload();
  };

  return <>
    <Button type={'link'} onClick={updateClick} className={'pl-0 pr-0'}>{t('更新字段名')}</Button>
    <Modal
      onOk={onOk}
      onCancel={onCancel}
      closeIcon={<IconClose/>}
      width={400}
      destroyOnClose
      title={t('更新字段名')}
      visible={visible}
      maskClosable={false}
      confirmLoading={submitLoading}
      cancelButtonProps={{
        className: styles.cancelButton,
        disabled: submitLoading,
      }}
      okButtonProps={{
        style: { background: '#0A6CFF', borderRadius: '3px' },
        disabled: modalLoading,
      }}
      className={styles.modal}
    >
      <Form form={form}>
        <Form.Item label={'GUID'} name={'field'}>
          <Select options={FILED_OPTIONS} allowClear={false}/>
        </Form.Item>
      </Form>
    </Modal>
  </>;
};
